export default __webpack_public_path__ + "images/057b3376ff59f3b82d5c3cf46e3d42bd-no-ironing.svg";